import { useApiInfiniteQuery } from "../../../services/api";

const limit = 20;

export function useGetCompanyPlaylistsQuery(params: { companyId: string }) {
  const query = useApiInfiniteQuery(
    "/webapp/public/playlists/company/:companyId",
    params.companyId === ""
      ? false
      : { param: { companyId: params.companyId }, query: { limit } }
  );

  const playlists = query.state === "success" ? query.docs : [];
  const playlistIds = playlists.map((playlist) => playlist.id).join(",");

  return {
    playlists,
    playlistIds,
    isLoading: query.state === "pending",
    isFetching: query.isFetching,
    fetchNextPage:
      query.state === "success" ? query.fetchNextPage : () => void 0,
    canFetchNextPage: query.state === "success" && query.canFetchNextPage,
  };
}
